import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { BorderContainer } from "../../atoms/border-container/BorderContainer";
import { Loader } from "../../atoms/loader/Loader";
import { Typography } from "../../atoms/typography/Typography";
import "./titleBorderContainer.scss";
export const TitleBorderContainer = memo(({ className = "", title, subtitle, children, isLoading = false, marginBottom = "0", testId, size = "default" }) => {
    return (_jsxs(BorderContainer, { testId: testId, marginBottom: marginBottom, size: size, className: className, children: [isLoading && _jsx(Loader, { isCentered: true }), _jsxs("div", { children: [_jsx("h2", { className: "header", children: title }), subtitle && (_jsx(Typography, { weight: "bold", component: "div", children: subtitle }))] }), children] }));
});
